import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import decodeHTMLEntities from "../../../utils/decodeHTMLentities";
const Logo = (props) => {
    const { logo, title } = props;
    return (React.createElement(Link, { to: "/", title: "Retour à l'accueil du site " + decodeHTMLEntities(title) },
        React.createElement(GatsbyImage, { image: getImage(logo), alt: "Retour à l'accueil du site " + decodeHTMLEntities(title) })));
};
export default Logo;
